import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import {
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR
} from "../lib/formsReducer";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { menuTranslation, menuItem } from "../app/schema";

export const POST_MENUS_TRANSLATIONS = "POST_MENUS_TRANSLATIONS";
export const POST_MENUS_TRANSLATIONS_SUCCESS = "POST_MENUS_TRANSLATIONS_SUCCESS";
export const POST_MENUS_TRANSLATIONS_ERROR = "POST_MENUS_TRANSLATIONS_ERROR";

export const PATCH_MENUS_TRANSLATION = "PATCH_MENUS_TRANSLATION";
export const PATCH_MENUS_TRANSLATION_SUCCESS = "PATCH_MENUS_TRANSLATION_SUCCESS";
export const PATCH_MENUS_TRANSLATION_ERROR = "PATCH_MENUS_TRANSLATION_ERROR";

export const DELETE_MENUS_TRANSLATION = "DELETE_MENUS_TRANSLATION";
export const DELETE_MENUS_TRANSLATION_SUCCESS = "DELETE_MENUS_TRANSLATION_SUCCESS";
export const DELETE_MENUS_TRANSLATION_ERROR = "DELETE_MENUS_TRANSLATION_ERROR";

export const GET_MENUS_TRANSLATION_FIELDS = "GET_MENUS_TRANSLATION_FIELDS";
export const GET_MENUS_TRANSLATION_FIELDS_SUCCESS = "GET_MENUS_TRANSLATION_FIELDS_SUCCESS";
export const GET_MENUS_TRANSLATION_FIELDS_ERROR = "GET_MENUS_TRANSLATION_FIELDS_ERROR";

export const POST_MENUS_TRANSLATION_FIELDS = "POST_MENUS_TRANSLATION_FIELDS";
export const POST_MENUS_TRANSLATION_FIELDS_SUCCESS = "POST_MENUS_TRANSLATION_FIELDS_SUCCESS";
export const POST_MENUS_TRANSLATION_FIELDS_ERROR = "POST_MENUS_TRANSLATION_FIELDS_ERROR";

export const SET_MENU_TRANSLATION_DATA_OBJECT = "SET_MENU_TRANSLATION_DATA_OBJECT";
export const MOVE_MENU_ITEM = "MOVE_MENU_ITEM";

// Validation
const validateForm = {
  createMenuTranslation: (validate, fields, oneField) => validate(
    fields,
    oneField
  )// .prop('name', 'Nazwa').required()
  .getErrors().promise,
  createMenusTranslationMenuItems: (validate, fields, oneField) => validate(
    fields,
    oneField
  )// .prop('name', 'Nazwa').required()
  .getErrors().promise
};

// Requests

const postMenusTranslations = (fetch, apiHost, accessToken, data) =>
  fetch(`${apiHost}/v1/menus-translations`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });

const patchMenusTranslation = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/menus-translations/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteMenusTranslation = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/menus-translations/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: "Nie można usunąć danych pola tłumaczenia kategorii, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

const getMenusTranslationsMenuItemsGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/menus-translations/${uid}/menu-items`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const postMenusTranslationsMenuItems = (
  fetch,
  apiHost,
  accessToken,
  uid,
  data
) =>
  fetch(`${apiHost}/v1/menus-translations/${uid}/menu-items`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });

// Actions

export function createMenuTranslation(data) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_MENUS_TRANSLATIONS],
    payload: {
      promise: validateForm
        ["createMenusTranslation"](validate, data)
        .then(() =>
          postMenusTranslations(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data
          ))
        .then(data => {
          return normalize(data, menuTranslation);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updateMenuTranslation(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_MENUS_TRANSLATION],
    payload: {
      promise: patchMenusTranslation(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, menuTranslation);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeMenuTranslation(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_MENUS_TRANSLATION],
    payload: {
      promise: deleteMenusTranslation(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function getMenusTranslationsMenuItems(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_MENUS_TRANSLATION_FIELDS],
    payload: {
      promise: getMenusTranslationsMenuItemsGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          return normalize(data, arrayOf(menuItem));
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    },
    meta: {
      uid
    }
  });
}

export function createMenusTranslationMenuItems(uid, data) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_MENUS_TRANSLATION_FIELDS],
    payload: {
      promise: validateForm
        ["createMenusTranslationMenuItems"](validate, data)
        .then(() =>
          postMenusTranslationsMenuItems(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            uid,
            data
          ))
        .then(data => {
          return normalize(data, menuItem);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function setMenuTranslationDataObject(uid, menuDataObject) {
  return {
    type: SET_MENU_TRANSLATION_DATA_OBJECT,
    payload: {
      uid,
      menuDataObject
    }
  };
}

export function moveMenuItem(dragIndex, hoverIndex, moveActionProps) {
  return {
    type: MOVE_MENU_ITEM,
    payload: {
      dragIndex,
      hoverIndex,
      moveActionProps
    }
  };
}

// Standard functions
export function validateFormFieldMenusTranslations(form, name, value) {
  const feature = "menusTranslations";
  let fields = {};
  fields[name] = value;
  return ({ fetch, validate, config, users }) => ({
    type: [`${VALIDATE_FORM_FIELD}_${feature.toUpperCase()}`],
    payload: {
      promise: validateForm[form](validate, fields, true).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/menuTranslations/actions.js